module.exports = __webpack_public_path__ + "img/colaborador(7).21f506a3.jpeg";